import React from 'react';
import styles from './PageLoader.module.scss';

interface Props {
  shouldDisplayLoader: boolean;
}

export const PageLoader: React.FC<Props> = ({ shouldDisplayLoader }) => {
  if (!shouldDisplayLoader) {
    return null;
  }

  return (
    <div className={styles.subscribtionLoader}>
      <div className={styles.subscribtionLoader2} />
    </div>
  );
};
